import type { InputHTMLAttributes, ReactNode } from "react";
import { cx } from "./cx";

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
}

export function Checkbox({ label, className, disabled, ...rest }: CheckboxProps) {
  return (
    <label className={cx("pz-check", disabled && "pz-check--disabled", className)}>
      <input type="checkbox" className="pz-check__input" disabled={disabled} {...rest} />
      {label != null && <span>{label}</span>}
    </label>
  );
}

export function Radio({ label, className, disabled, ...rest }: CheckboxProps) {
  return (
    <label className={cx("pz-check", disabled && "pz-check--disabled", className)}>
      <input type="radio" className="pz-check__input" disabled={disabled} {...rest} />
      {label != null && <span>{label}</span>}
    </label>
  );
}
